import React from 'react';
import Layout from '../components/Layout';
import GrnList from '../components/GrnList';


/**
 * Página de listado de órdenes de compra
 * Utiliza el componente Layout para la estructura básica
 * y el componente ASNList para mostrar la lista de órdenes
 */
const Sending = () => {
  return (
    <Layout>
      <div>
        <GrnList />
      </div>
    </Layout>
  );
};

export default Sending;